import type {
  THygieneTaskCode,
  THygieneTaskType,
} from '@/react-query/insights/types';

import { TYPE_TO_TASK_CODE } from '../types';

// Helper function to convert task types to task codes
export const taskTypesToCodes = (
  taskTypes: THygieneTaskType[],
): THygieneTaskCode[] => {
  return taskTypes.map(
    (taskType) => TYPE_TO_TASK_CODE[taskType] as THygieneTaskCode,
  );
};

// Helper function to convert task codes to task types (HRF)
export const taskCodesToTypes = (
  taskCodes: THygieneTaskCode[],
): THygieneTaskType[] => {
  return taskCodes
    .map((code) => {
      const taskType = Object.entries(TYPE_TO_TASK_CODE).find(
        ([, taskCode]) => taskCode === code,
      )?.[0] as THygieneTaskType;
      return taskType;
    })
    .filter(Boolean) as THygieneTaskType[];
};
